import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { ConversationDetailsState, SLICE_NAME } from './models';

const conversationDetailsSelector = (state: RootState): ConversationDetailsState => state[SLICE_NAME];

export const selectConversationDetails = createSelector(
  conversationDetailsSelector,
  (state: ConversationDetailsState) => state.item,
);

export const selectConversationChannelTheme = createSelector(
  conversationDetailsSelector,
  (state: ConversationDetailsState) => state.channelTheme,
);

export const selectConversationChannelThemeIsLoading = createSelector(
  conversationDetailsSelector,
  (state: ConversationDetailsState) => state.isChannelThemeLoading,
);

export const selectConversationDetailsIsLoading = createSelector(
  conversationDetailsSelector,
  (state: ConversationDetailsState) => state.isLoading,
);

export const selectConversationDetailsError = createSelector(
  conversationDetailsSelector,
  (state: ConversationDetailsState) => state.error,
);
